import React from 'react';
import { Box, Checkbox as NBCheckbox, themeTools } from 'native-base';
import PropTypes from 'prop-types';
import styleShape from 'react-style-proptype';
import { WithColorMode } from '../hoc';
import { FormControl } from '~/native-ui/FormControl';
import { Pressable } from '~/native-ui/Pressable';

const factory = (Check) => {
    class Checkbox extends React.Component {
        static propTypes = {
            checked: PropTypes.bool,
            children: PropTypes.node,
            className: PropTypes.string,
            disabled: PropTypes.bool,
            readonly: PropTypes.bool,
            label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
            name: PropTypes.string,
            onChange: PropTypes.func,
            onMouseEnter: PropTypes.func,
            onMouseLeave: PropTypes.func,
            style: styleShape,
            theme: PropTypes.shape({
                disabled: PropTypes.string,
                field: PropTypes.string,
                input: PropTypes.string,
                ripple: PropTypes.string,
            }),
        };

        static defaultProps = {
            checked: false,
            className: '',
            disabled: false,
        };

        handleToggle = (isChecked, event) => {
            if (!this.props.disabled && this.props.onChange) {
                this.props.onChange(!this.props.checked, event);
            }
        };

        renderCheckboxLabel() {
            const { label, tooltip } = this.props;
            return label ? <FormControl.Label label={label} tooltip={tooltip}></FormControl.Label> : null;
        }

        renderCheckboxDescription() {
            const { children } = this.props;
            return children ? (
                <Box flex="1">
                    <Box width="100%" ml="2">
                        {children}
                    </Box>
                </Box>
            ) : null;
        }

        render() {
            const { checked, disabled, readonly } = this.props;

            const checkboxProps = {
                value: this.props.value ?? true,
                onChange: this.handleToggle,
                alignItems: 'center',
                isChecked: checked || false,
                isDisabled: disabled || false,
                _interactionBox: readonly ? { display: 'none' } : undefined,
                _checked: readonly ? { bg: themeTools.mode(`muted.50`, `muted.800`)(this.props) } : undefined,
                _icon: readonly ? { color: 'primary.500' } : undefined,
            };

            const props = {
                py: '10px',
                maxW: this.props.children ? null : '50px',
            };

            return (
                <FormControl>
                    {this.renderCheckboxLabel()}
                    <Box {...props}>
                        <Pressable>
                            <Check {...checkboxProps}>{this.renderCheckboxDescription()}</Check>
                        </Pressable>
                    </Box>
                </FormControl>
            );
        }
    }

    return WithColorMode(Checkbox);
};

const Checkbox = factory(NBCheckbox);
export { factory as checkboxFactory };
export default Checkbox;
export { Checkbox };
